import { SET_ERROR_RESERVE } from './../actions/setNewStateToReserve';

export const errorReserve = (state = {}, action) => {
    switch(action.type) {
        case SET_ERROR_RESERVE:{
            return action.payload;
        }
        default:
            return state;
    }
}